var _excluded = ["gap", "reverse", "justifyContent", "alignItems", "children", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import { string, oneOf, node, bool } from 'prop-types';
import './Row.scss';
var propTypes = {
  /** Use `<Col>` components as children inside `<Row>` */
  children: node.isRequired,

  /** Choose where you want gap between your columns in the row: */
  gap: oneOf(['gap', 'rowgap', 'colgap', 'nogap']),

  /** Reverse direction of children */
  reverse: bool,

  /** Justify content horizontally in the row: */
  justifyContent: oneOf(['start', 'center', 'end', 'around', 'between']),

  /** Align items vertically in the row */
  alignItems: oneOf(['start', 'center', 'end', 'stretch']),

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  gap: 'gap'
};
/** Row is used as a wrapper around Columns. It controls the gap, positioning,
 * alignment and direction of its children.
 * @visibleName Grid Row
 * */

var Row = function Row(_ref) {
  var gap = _ref.gap,
      reverse = _ref.reverse,
      justifyContent = _ref.justifyContent,
      alignItems = _ref.alignItems,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-row', {
    'rds-gap': gap === 'gap' || gap === '' || gap === null,
    'rds-colgap': gap === 'colgap',
    'rds-rowgap': gap === 'rowgap',
    '': gap === 'nogap',
    'rds-row-reverse': reverse,
    'rds-jc-start': justifyContent === 'start',
    'rds-jc-center': justifyContent === 'center',
    'rds-jc-end': justifyContent === 'end',
    'rds-jc-around': justifyContent === 'around',
    'rds-jc-between': justifyContent === 'between',
    'rds-ai-start': alignItems === 'start',
    'rds-ai-center': alignItems === 'center',
    'rds-ai-end': alignItems === 'end',
    'rds-ai-stretch': alignItems === 'stretch'
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: componentClassNames
  }, rest), children);
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
export default Row;